import moment from 'moment'
import v4 from 'uuid/v4'

// 2018-10-10T17:35:31.746369+01:00
const today = moment()
const birthPortuguesPatient = moment().year(today.get('year') - 1)
const birthGermanPatient = moment().year(today.get('year') - 5)
const staticBirthPT = birthPortuguesPatient.format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ')
const staticBirthDE = birthGermanPatient.format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ')
// const immunizationsUntil10Years = [
//   {
//     'id': v4(),
//     'date': staticBirthPT,
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '66071002',
//           'name': 'Hepatite B',
//           'displayKey': 'hepatitis_b'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(2, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '66071002',
//           'name': 'Hepatite B',
//           'displayKey': 'hepatitis_b'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '709410003',
//           'name': 'Hib',
//           'displayKey': 'hib'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '397428000',
//           'name': 'Difteria',
//           'displayKey': 'diphtheria'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '76902006',
//           'name': 'Tétano',
//           'displayKey': 'tetanus'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '27836007',
//           'name': 'Tosse Convulsa',
//           'displayKey': 'pertussis'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '398102009',
//           'name': 'Poliomielite',
//           'displayKey': 'poliomyelitis'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '9861002',
//           'name': 'Doença Pneumocócica',
//           'displayKey': 'pneumococcal_disease'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(4, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '709410003',
//           'name': 'Hib',
//           'displayKey': 'hib'
//         }
//       },
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '397428000',
//           'name': 'Difteria',
//           'displayKey': 'diphtheria'
//         }
//       },
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '76902006',
//           'name': 'Tétano',
//           'displayKey': 'tetanus'
//         }
//       },
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '27836007',
//           'name': 'Tosse Convulsa',
//           'displayKey': 'pertussis'
//         }
//       },
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '398102009',
//           'name': 'Poliomielite',
//           'displayKey': 'poliomyelitis'
//         }
//       },
//       {
//         'seqNumber': 2,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '9861002',
//           'name': 'Doença Pneumocócica',
//           'displayKey': 'pneumococcal_disease'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(6, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '66071002',
//           'name': 'Hepatite B',
//           'displayKey': 'hepatitis_b'
//         }
//       },
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '709410003',
//           'name': 'Hib',
//           'displayKey': 'hib'
//         }
//       },
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '397428000',
//           'name': 'Difteria',
//           'displayKey': 'diphtheria'
//         }
//       },
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '76902006',
//           'name': 'Tétano',
//           'displayKey': 'tetanus'
//         }
//       },
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '27836007',
//           'name': 'Tosse Convulsa',
//           'displayKey': 'pertussis'
//         }
//       },
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '398102009',
//           'name': 'Poliomielite',
//           'displayKey': 'poliomyelitis'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(12, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 3,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '9861002',
//           'name': 'Doença Pneumocócica',
//           'displayKey': 'pneumococcal_disease'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '23511006',
//           'name': 'Doença Meningocócica C',
//           'displayKey': 'meningococcal_infection'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '14189004',
//           'name': 'Sarampo',
//           'displayKey': 'Sarampo'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '240526004',
//           'name': 'Parotidite Epidémica',
//           'displayKey': 'Parotidite Epidémica'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '36653000',
//           'name': 'Rubéola',
//           'displayKey': 'Rubéola'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(18, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 4,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '709410003',
//           'name': 'hib',
//           'displayKey': 'hib'
//         }
//       },
//       {
//         'seqNumber': 4,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '397428000',
//           'name': 'Difteria',
//           'displayKey': 'diphtheria'
//         }
//       },
//       {
//         'seqNumber': 4,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '76902006',
//           'name': 'Tétano',
//           'displayKey': 'tetanus'
//         }
//       },
//       {
//         'seqNumber': 4,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '27836007',
//           'name': 'Tosse Convulsa',
//           'displayKey': 'pertussis'
//         }
//       },
//       {
//         'seqNumber': 4,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '398102009',
//           'name': 'Poliomielite',
//           'displayKey': 'poliomielitis'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(5, 'years').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '397428000',
//           'name': 'Difteria',
//           'displayKey': 'diphtheria'
//         }
//       },
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '76902006',
//           'name': 'Tétano',
//           'displayKey': 'tetanus'
//         }
//       },
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '27836007',
//           'name': 'Tosse Convulsa',
//           'displayKey': 'pertussis'
//         }
//       },
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '398102009',
//           'name': 'Poliomielite',
//           'displayKey': 'poliomielitis'
//         }
//       },
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '14189004',
//           'name': 'Sarampo',
//           'displayKey': 'measles'
//         }
//       },
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '240526004',
//           'name': 'Parotidite Epidémica',
//           'displayKey': 'mumps'
//         }
//       },
//       {
//         'seqNumber': 5,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '36653000',
//           'name': 'Rubéola',
//           'displayKey': 'rubella'
//         }
//       }
//     ]
//   },
//   {
//     'id': v4(),
//     'date': moment(new Date(staticBirthPT)).add(10, 'years').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
//     'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
//     'observations': 'Sem Observações',
//     'metadata': {
//       'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
//     },
//     'protoInfo': [
//       {
//         'seqNumber': 6,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '76902006',
//           'name': 'Tétano',
//           'displayKey': 'tetanus'
//         }
//       },
//       {
//         'seqNumber': 1,
//         'status': 'ONTIME',
//         'pathology': {
//           'id': '371973000',
//           'name': 'Cancro Colo do Útero',
//           'displayKey': 'uterine_cancer'
//         }
//       }
//     ]
//   }
// ]

const portuguesImmunizationsBefore1Year = [
  {
    'id': v4(),
    'date': staticBirthPT,
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(2, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tétano',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '9861002',
          'name': 'Doença Pneumocócica',
          'displayKey': 'pneumococcal_disease'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(4, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tétano',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '9861002',
          'name': 'Doença Pneumocócica',
          'displayKey': 'pneumococcal_disease'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(6, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tétano',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      }
    ]
  }
]

const brasilianImmunizationsBefore1Year = [
  {
    'id': v4(),
    'date': staticBirthPT,
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(2, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tétano',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '9861002',
          'name': 'Doença Pneumocócica',
          'displayKey': 'pneumococcal_disease'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '64694002',
          'name': 'Rotavirus',
          'displayKey': 'rotavirus'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(3, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '23511006',
          'name': 'Men. C',
          'displayKey': 'meningococcal_infection'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(4, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tétano',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '9861002',
          'name': 'Doença Pneumocócica',
          'displayKey': 'pneumococcal_disease'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '64694002',
          'name': 'Rotavirus',
          'displayKey': 'rotavirus'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(5, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '23511006',
          'name': 'Men. C',
          'displayKey': 'meningococcal_infection'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(6, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 4,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tétano',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 3,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthPT)).add(9, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '16541001',
          'name': 'Febre Amarela',
          'displayKey': 'yellow_fever'
        }
      }
    ]
  }
]

const germanImmunizations = [
  {
    'id': v4(),
    'date': moment(new Date(staticBirthDE)).add(6, 'week').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '18624000',
          'name': 'Rotavirus',
          'displayKey': 'rotavirus'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthDE)).add(2, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo': [
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '76902006',
          'name': 'Tetanus',
          'displayKey': 'tetanus'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '397428000',
          'name': 'Difteria',
          'displayKey': 'diphtheria'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '27836007',
          'name': 'Tosse Convulsa',
          'displayKey': 'pertussis'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '709410003',
          'name': 'Hib',
          'displayKey': 'hib'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '398102009',
          'name': 'Poliomielite',
          'displayKey': 'poliomyelitis'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '66071002',
          'name': 'Hepatite B',
          'displayKey': 'hepatitis_b'
        }
      },
      {
        'seqNumber': 1,
        'status': 'ONTIME',
        'pathology': {
          'id': '9861002',
          'name': 'Doença Pneumocócica',
          'displayKey': 'pneumococcal_disease'
        }
      },
      {
        'seqNumber': 2,
        'status': 'ONTIME',
        'pathology': {
          'id': '18624000',
          'name': 'Rotavirus',
          'displayKey': 'rotavirus'
        }
      }
    ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthDE)).add(4, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value':
        'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo':
      [
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '76902006',
            'name': 'Tetanus',
            'displayKey': 'tetanus'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '397428000',
            'name': 'Difteria',
            'displayKey': 'diphtheria'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '27836007',
            'name': 'Tosse Convulsa',
            'displayKey': 'pertussis'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '709410003',
            'name': 'Hib',
            'displayKey': 'hib'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '398102009',
            'name': 'Poliomielite',
            'displayKey': 'poliomyelitis'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '66071002',
            'name': 'Hepatite B',
            'displayKey': 'hepatitis_b'
          }
        }
      ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthDE)).add(6, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo':
      [
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '76902006',
            'name': 'Tetanus',
            'displayKey': 'tetanus'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '397428000',
            'name': 'Difteria',
            'displayKey': 'diphtheria'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '27836007',
            'name': 'Tosse Convulsa',
            'displayKey': 'pertussis'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '709410003',
            'name': 'Hib',
            'displayKey': 'hib'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '398102009',
            'name': 'Poliomielite',
            'displayKey': 'poliomyelitis'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '66071002',
            'name': 'Hepatite B',
            'displayKey': 'hepatitis_b'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '9861002',
            'name': 'Doença Pneumocócica',
            'displayKey': 'pneumococcal_disease'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '18624000',
            'name': 'Rotavirus',
            'displayKey': 'rotavirus'
          }
        }
      ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthDE)).add(11, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo':
      [
        {
          'seqNumber': 4,
          'status': 'ONTIME',
          'pathology': {
            'id': '76902006',
            'name': 'Tetanus',
            'displayKey': 'tetanus'
          }
        },
        {
          'seqNumber': 4,
          'status': 'ONTIME',
          'pathology': {
            'id': '397428000',
            'name': 'Difteria',
            'displayKey': 'diphtheria'
          }
        },
        {
          'seqNumber': 4,
          'status': 'ONTIME',
          'pathology': {
            'id': '27836007',
            'name': 'Tosse Convulsa',
            'displayKey': 'pertussis'
          }
        },
        {
          'seqNumber': 4,
          'status': 'ONTIME',
          'pathology': {
            'id': '709410003',
            'name': 'Hib',
            'displayKey': 'hib'
          }
        },
        {
          'seqNumber': 4,
          'status': 'ONTIME',
          'pathology': {
            'id': '398102009',
            'name': 'Poliomielite',
            'displayKey': 'poliomyelitis'
          }
        },
        {
          'seqNumber': 4,
          'status': 'ONTIME',
          'pathology': {
            'id': '66071002',
            'name': 'Hepatite B',
            'displayKey': 'hepatitis_b'
          }
        },
        {
          'seqNumber': 3,
          'status': 'ONTIME',
          'pathology': {
            'id': '9861002',
            'name': 'Doença Pneumocócica',
            'displayKey': 'pneumococcal_disease'
          }
        },
        {
          'seqNumber': 1,
          'status': 'ONTIME',
          'pathology': {
            'id': '14189004',
            'name': 'Measles',
            'displayKey': 'measles'
          }
        },
        {
          'seqNumber': 1,
          'status': 'ONTIME',
          'pathology': {
            'id': '240526004',
            'name': 'Mumps',
            'displayKey': 'mumps'
          }
        },
        {
          'seqNumber': 1,
          'status': 'ONTIME',
          'pathology': {
            'id': '36653000',
            'name': 'Rubella',
            'displayKey': 'rubella'
          }
        },
        {
          'seqNumber': 1,
          'status': 'ONTIME',
          'pathology': {
            'id': '38907003',
            'name': 'Varicella',
            'displayKey': 'varicella'
          }
        }
      ]
  },
  {
    'id': v4(),
    'date': moment(new Date(staticBirthDE)).add(15, 'month').format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ'),
    'professional': 'facb097f-5858-4faf-8c59-52cc243f7f22',
    'observations': 'Sem Observações aqui',
    'metadata': {
      'value': 'e3825dbd-9ed7-421e-8824-aff238682b03'
    },
    'protoInfo':
      [
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '14189004',
            'name': 'Measles',
            'displayKey': 'measles'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '240526004',
            'name': 'Mumps',
            'displayKey': 'mumps'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '36653000',
            'name': 'Rubella',
            'displayKey': 'rubella'
          }
        },
        {
          'seqNumber': 2,
          'status': 'ONTIME',
          'pathology': {
            'id': '38907003',
            'name': 'Varicella',
            'displayKey': 'varicella'
          }
        },
        {
          'seqNumber': 1,
          'status': 'ONTIME',
          'pathology': {
            'id': '23511006',
            'name': 'Men C',
            'displayKey': 'meningococcal_infection'
          }
        }
      ]
  }
]

export { portuguesImmunizationsBefore1Year, germanImmunizations, brasilianImmunizationsBefore1Year }
